import styled from "@emotion/styled";
import { Text } from "@atlas-int/ui";
import FAQContent from "./Content";
import { DetailsPageContainer } from "../../components/layout/StaticPageLayout";
import ResearchFooter from "../../components/footer/ResearchFooter";
import { useLocation } from "react-router";
import { useEffect } from "react";

const PageTitle = styled(Text)`
  margin-top: 0;
`;

const FAQ = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <DetailsPageContainer>
        <PageTitle variant="heading-1">Frequently Asked Questions</PageTitle>
        <FAQContent />
      </DetailsPageContainer>
      <ResearchFooter />
    </>
  );
};

export default FAQ;
